import { render, staticRenderFns } from "./DictItem.vue?vue&type=template&id=235fe915&scoped=true"
import script from "./DictItem.vue?vue&type=script&lang=js"
export * from "./DictItem.vue?vue&type=script&lang=js"
import style0 from "./DictItem.vue?vue&type=style&index=0&id=235fe915&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235fe915",
  null
  
)

export default component.exports